import { selectFlags } from '../data-layer/experiments/selectors';
import { useSelector } from '../data-layer/useSelector';
import { TFlagsAllowed } from '../generated/flags.types';

export function useExperimentFlag<K extends keyof TFlagsAllowed>(
    name: K,
): TFlagsAllowed[K] | undefined {
    const flags = useSelector((state) => selectFlags(state));

    return flags ? (flags[name] as TFlagsAllowed[K]) : undefined;
}
